import { render, staticRenderFns } from "./upgrade_modal.vue?vue&type=template&id=0b9e3ab7&scoped=true&"
import script from "./upgrade_modal.vue?vue&type=script&lang=js&"
export * from "./upgrade_modal.vue?vue&type=script&lang=js&"
import style0 from "./upgrade_modal.vue?vue&type=style&index=0&id=0b9e3ab7&lang=scss&scoped=true&"
import style1 from "./upgrade_modal.vue?vue&type=style&index=1&id=0b9e3ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e3ab7",
  null
  
)

export default component.exports